function redirectToRegisterPage() {
  window.location.href = '/register.html'
}

function redirectToRUNSPage(crawlerId) {
  window.location.href = `/runs-master?id=${crawlerId}`
}

function redirectToLogsPage(crawlerId) {
  window.location.href = `/crawler-logs?id=${crawlerId}`
}

function redirectToConfigPage(crawlerId) {
  window.location.href = `/crawler-details?id=${crawlerId}`
}

document.addEventListener('DOMContentLoaded', () => {
  const registerButton = document.querySelector('.btn-register')
  if (registerButton) {
    registerButton.addEventListener('click', redirectToRegisterPage)
  }

  const runsButton = document.querySelector('.btn-RUNS')
  if (runsButton) {
    runsButton.addEventListener('click', redirectToRUNSPage)
  }
})

